import { Cpu, Video, Target, LineChart } from "lucide-react";
import { SERVICES } from "../data";
import { Reveal } from "./Reveal";

const ICONS = [Cpu, Video, Target, LineChart];

export const ModernServices = () => (
  <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#0a0a0a] text-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="eyebrow text-gold mb-4">Technologically Advanced</p>
            <h2 className="font-heading font-light text-4xl sm:text-5xl tracking-tight leading-tight">
              Modern services, unmatched by anyone else
            </h2>
            <p className="text-white/70 font-light text-lg mt-6 leading-relaxed">
              We blend over a decade of local expertise with the latest real estate technology —
              giving our clients an edge that traditional agents simply can't offer.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-white/10">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={s.title} delay={i * 0.1} className="bg-[#0a0a0a]">
                <div
                  data-testid={`service-${i}`}
                  className="p-9 h-full hover:bg-white/[0.03] transition-colors"
                >
                  <Icon size={28} className="text-gold" strokeWidth={1.5} />
                  <h3 className="font-heading text-2xl mt-6">{s.title}</h3>
                  <p className="text-white/60 font-light text-sm mt-3 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
